// * Styles
import "../App.css";
import "../styles/JourneyRightSection/responsive.css";
// * React Hooks
import { useEffect, useRef, useState, useContext } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
// * APIs
import { getOtp, resendOtp } from "../store/actions/getOtp";
import {
  getAutoPullBureauDetails,
  getAutoPullBureauDetailsSuccess,
} from "../store/actions/autoPullBureauDetails";
import { addJourney } from "../store/actions/addJourney";
import { journeyFields } from "../store/actions/journeyFields";
import { verifyOtp } from "../store/actions/verifyOtp";
import {
  realTimeLeadPush,
  realTimeLeadPushSuccess,
  realTimeLeadPushError,
} from "../store/actions/realTimeLeadPush";
import {
  getProfileDetails,
  getProfileDetailsSuccess,
} from "../store/actions/profile";
// * NPM Packages
import { Carousel } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import queryString from "query-string";
import PinCodeDirectory from "india-pincode-lookup";
import useReactIpLocation from "react-ip-details";
import { useCookies } from "react-cookie";

// * Contexts
import ErrorContext from "../context/ErrorProvider";
import CustomerContext from "../context/CustomerContext";

// ** Helper Functions
import { validateEmail, calculateAge } from "../utils/common";

import {
  removeAllCookies,
  isCookieExpired,
  getCookiePathFromURL,
} from "../helpers";
// ** Micro Components
import TextInputField from "../components/DataInputFields/TextInputField/TextInputField";
import ContinueButton from "../components/Buttons/SlideContinueButton/ContinueButton";
import SelectorButton from "../components/Buttons/SelectorButton/SelectorButton";
import PowerdByRoopya from "../components/PowerdByRoopya/PowerdByRoopya";

// ** Material Icons
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// * Images
import YouindiLogo from "../imagesLogo/youindiLogo.png";

// * Journey Slides
import OTPSlide from "../components/Slides/OTPSlide/OTPSlide";
import FullNameDobPANSlide from "../components/Slides/Other/FullNameDOBPAN/Slide";

// ** Error messages and error types
import * as Errors from "../utils/errors";
import {
  CONTACT_ID,
  LEAD_ID,
  Authorization_TOKEN,
  JOURNEY_AUTH_TOKEN,
  LAST_ACTIVE_JOURNEY_SLIDE,
  EMPLOYEMENT_TYPE,
  CUSTOMER_DETAILS,
} from "../constants";
import * as urls from "../urls"; ///utils/urls
// * Selcector Input Options

import { Typography } from "@mui/material";
// * States, City
let State = require("country-state-city").State;
let City = require("country-state-city").City;

let contact_id12 = "";
console.log(contact_id12, "contact_id");

// const TokenForCustomers12 = getCookie("tokenForCustomers");
// console.log(TokenForCustomers12,"tokenForCustomers")

const JourneyForm = (props) => {
  //const domainName = "yoindi";
  const CookiePath = getCookiePathFromURL(window.location.href);

  let domain = window.location.host.split(".")[0];
  if (window.location.host.includes("localhost")) {
    domain = "yoindi";
  }
  console.log("domain name", domain);
  
  const { ipResponse } = useReactIpLocation({ numberToConvert: 100 });
  let url = useLocation().search;
  let queryValues = queryString.parse(url);
  const [orgLogoData, setOrgLogoData] = useState(null);
  const JourneyVersion = queryValues?.jrnyTyp;
  console.log("orgLogoData",orgLogoData)
  console.log('Customer Portal 13:48')
  const { apiKey, apiSecret } = useParams();
  const [appId, setAppId] = useState({});
  const [ContactID, setContactID] = useState(1);
  console.log("ContactID", ContactID)
  const [TokenForCustomers, setTokenForCustomers] = useState(1);
  const [newCustomer, setNewCustomer] = useState(false);
  // console.log("TokenForCustomers :", TokenForCustomers);

  const [salary, setSalary] = useState(null);

  const [userToken, setUserToken] = useState({});
  // console.log("userToken", userToken)
  // * Cookies
  const [cookies, setCookie] = useCookies(["user"]);

  const [scrollPosition, setScrollPosition] = useState(0);
  // * Slide trackers States
  const [activeSlide, setActiveSlide] = useState(0);
  console.log("activeSlide",activeSlide)

  const [previousSlide, setPreviousSlide] = useState(activeSlide);
  // console.log(activeSlide, "activeSlide");
  // console.log(previousSlide, "previousSlide");
  // * State to handle API loading
  const [loading, setLoading] = useState(false);

  // * Context to store customer details
  const { customerDetails, setCustomerDetails } = useContext(CustomerContext);
  console.log("customerDetails", customerDetails);
  console.log("customerDetails?.contactId",customerDetails?.contactId)
  // * State to handle Journey error
  const { error, setError } = useContext(ErrorContext);
  // * State to store all selectors element values
  const [selectorValues] = useState({
    gender: "",
    maritalStatus: "",
    hasCoApplicant: null,
    employementType: "",
  });
  // * Mobile Number Slide States and Refs
  const mobileNumberRef = useRef();
  // * OTP Slide States and Refs
  const otpRefKey1 = useRef();
  const otpRefKey2 = useRef();
  const otpRefKey3 = useRef();
  const otpRefKey4 = useRef();

  // * FullName DOB PAN Slide States and Refs
  const ageRef = useRef();
  // * Email Address
  const emailRef = useRef();
  // * Monthly Income States and Refs
  const monthlyIncomeRef = useRef();
  // * Salary Type Ref

  // * Residential Address States and Refs
  const [residentialCity, setResidentialCity] = useState("AP");
  const residentialAddress1Ref = useRef();
  const residentialAddress2Ref = useRef();
  const residentialCityRef = useRef();
  const residentialStateRef = useRef();
  const residentialPinRef = useRef();
  // * Office Address States and Refs
  const [officeCity, setOfficeCity] = useState("AP");
  const officeCityRef = useRef();
  const officeStateRef = useRef();
  const officePinRef = useRef();
  // * Employement Type State
  const [employmentType, setEmploymentType] = useState("");

  // * Company Name ref
  const companyNameRef = useRef();

  // * APIs Defination
  const navigate = useNavigate();

////customersLogo Apis////
useEffect(() => {
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${urls.CustomersLogo}`;
  const headers = {
    "Content-Type": "application/json",
    domain_name: domain,
  };

  fetch(apiUrl, {
    method: "GET",
    headers: headers,
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("org logo data", data?.data?.documents);
      setOrgLogoData(data?.data?.documents);
    })
    .catch((error) => {
      const { response } = error;
      console.log("org_error=>", { response, error });
      console.error(error);

      const { data } = response;

      props.updateAlertMsg({
        message:
          (data && data.message) ||
          "Something went wrong with organization Logo",
        messageType: "error",
      });
    });
}, []);
////

  useEffect(() => {
    queryValues.userToken = userToken;
  }, [queryValues, userToken]);

  useEffect(() => {
    console.log(cookies, "COOKIES");
    if (cookies.token) {
      const {
        token,
        employmentType,
        hasCoApplicant,
        full_name,
        contactID,
        tokenForCustomers,

        customerAge,
      } = cookies;

      const isTokenExpired = isCookieExpired("tokenForCustomers");
      if (!isTokenExpired) {
        if (customerAge) {
          ageRef.current = customerAge;
        }
        if (employmentType && !hasCoApplicant) {
          setEmploymentType(employmentType);
        }
        setContactID(parseInt(ContactID));
        setTokenForCustomers(TokenForCustomers);
        setUserToken(TokenForCustomers);
        // setAppId(appID);
      } else {
        removeAllCookies(CookiePath);
      }
    } else {
      removeAllCookies(CookiePath);
    }
  }, []);

  useEffect(
    () =>
      window.addEventListener("scroll", () =>
        setScrollPosition(window.pageYOffset)
      ),
    []
  );

  function switchToNextSlide(slide) {
    setPreviousSlide(activeSlide);

    if (slide === 9) {
      // Slide 8 is the last slide you want to stop at
      setActiveSlide(8);
      setCookie(LAST_ACTIVE_JOURNEY_SLIDE, 8, {
        path: CookiePath,
      });
    } else {
      setActiveSlide(slide);
      setCookie(LAST_ACTIVE_JOURNEY_SLIDE, slide, {
        path: CookiePath,
      });
    }
  }

  function switchToPreviousSlide(slide) {
    if (error.error) {
      setError({
        error: false,
        type: "",
        message: "",
      });
    }
  }
  function switchToPreviousSlide(slide) {
    if (error.error) {
      setError({
        error: false,
        type: "",
        message: "",
      });
    }
    setPreviousSlide(slide - 1);
    setActiveSlide(slide);
  }

  function validateMobileNumber(mobileNumber, errorType) {
    if (mobileNumber === "") {
      setError({
        error: true,
        type: errorType,
        message: Errors.NULL_PHONE_ERROR,
      });
      return false;
    }
    if (isNaN(mobileNumber)) {
      setError({
        error: true,
        type: errorType,
        message: Errors.INVALID_DIGITS_PHONE_ERROR,
      });
      mobileNumberRef.current.value = "";
      return false;
    }
    if (mobileNumber.charAt(0) !== "6") {
      if (mobileNumber.charAt(0) !== "7") {
        if (mobileNumber.charAt(0) !== "8") {
          if (mobileNumber.charAt(0) !== "9") {
            setError({
              error: true,
              type: errorType,
              message: Errors.INVALID_PHONE_FORMAT_ERROR,
            });
            mobileNumberRef.current.value = "";
            return false;
          }
        }
      }
    }
    if (mobileNumber.length > 10 || mobileNumber.length < 10) {
      setError({
        error: true,
        type: errorType,
        message: Errors.INVALID_LENGTH_PHONE_ERROR,
      });
      return false;
    }
    if (mobileNumber.length === 10) {
      setError({
        error: false,
        type: "",
        message: "",
      });
    }
    return true;
  }

  function validatePAN(PAN) {
    if (PAN !== "") {
      if (PAN.length < 10 || PAN.length > 10) {
        return false;
      }
      if (!/[0-9]/.test(PAN) || !/[a-zA-Z]/.test(PAN)) {
        return false;
      }
      if (PAN.includes(" ")) {
        return false;
      }
      let PANregex = new RegExp(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/);
      // if (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(PAN)) {
      if (PANregex.test(PAN)) {
        return false;
      }
      if (PAN.charAt(3) === "P" || PAN.charAt(3) === "p") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  // * Function to handle individual OTP input field
  function handleOtp(otpKey, reference) {
    if (otpKey === "") {
      setError({
        error: true,
        type: Errors.OTP_ERROR_TYPE,
        message: Errors.NULL_OTP_ERROR,
      });
      reference.current.value = "";
      return false;
    }
    if (isNaN(otpKey)) {
      setError({
        error: true,
        type: Errors.OTP_ERROR_TYPE,
        message: Errors.INVALID_OTP_DIGIT_ERROR,
      });
      reference.current.value = "";
      return false;
    }
    if (error.error && error.type === Errors.OTP_ERROR_TYPE) {
      setError({
        error: false,
        type: "",
        message: "",
      });
    }
    if (reference.current.nextSibling) reference.current.nextSibling.focus();
    return true;
  }
  // * Function to get OTP
  async function sendOTP() {
    const mobileNumber = mobileNumberRef.current.value;

    window.webengage.track("Enter Mobile Number", {
      "Value Entered": mobileNumber,
    });
    window.webengage.user.setAttribute("we_phone", mobileNumber);
    window.webengage.user.login(mobileNumber);

    if (validateMobileNumber(mobileNumber, Errors.MOBILE_NUMBER_ERROR_TYPE)) {
      setLoading(true);

      const getOtpData = {
        ...queryValues,
        phone: mobileNumber,
        countryCode: "+91",
        ip: ipResponse?.IPv4,
      };
      const Payload = {
        getOtpData: getOtpData,

        // apiKey: apiKey,
        // apiSecret: apiSecret,
      };
      return new Promise((resolve, reject) => {
        props.getOtp(Payload, resolve, reject);
      })
        .then((response) => {
          const {
            id,
            address,
            address2,
            montly_income,
            pan,
            full_name,
          } = response?.data?.contact;

          let details = { contactId: id };
          // * If customer has all these attributes, redirect the customer to dashboard after verify OTP.
          if ((address && address2, montly_income, pan, full_name)) {
            setNewCustomer(false);
            details = {
              ...details,
              address,
              address2,
              montly_income,
              pan,
              full_name,
            };
            setCookie(
              CUSTOMER_DETAILS,
              { ...customerDetails, ...details },
              {
                path: CookiePath,
              }
            );
          } else {
            setNewCustomer(true);
          }
          setCustomerDetails({
            ...customerDetails,
            ...details,
            [Authorization_TOKEN]: response.data?.TokenForCustomers,
          });
          setCookie(Authorization_TOKEN, response.data?.TokenForCustomers, {
            path: CookiePath,
          });
          setCookie(CONTACT_ID, response.data?.contact?.id, {
            path: CookiePath,
          });
          setCookie(LEAD_ID, response.data?.lead_details?.id, {
            path: CookiePath,
          });
          

          switchToNextSlide(activeSlide + 1);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }
  // * Function to handle verifyOTP functionality
  function verifyOTP() {
    const otpKey1 = otpRefKey1.current.value;
    const otpKey2 = otpRefKey2.current.value;
    const otpKey3 = otpRefKey3.current.value;
    const otpKey4 = otpRefKey4.current.value;

    let otpErrorObj = error;

    if (otpKey1 === "") {
      otpErrorObj = {
        type: Errors.OTP_ERROR_TYPE,
        error: true,
        message: Errors.OTP_ERROR,
      };
    }
    if (otpKey2 === "") {
      otpErrorObj = {
        type: Errors.OTP_ERROR_TYPE,
        error: true,
        message: Errors.OTP_ERROR,
      };
    }
    if (otpKey3 === "") {
      otpErrorObj = {
        type: Errors.OTP_ERROR_TYPE,
        error: true,
        message: Errors.OTP_ERROR,
      };
    }
    if (otpKey4 === "") {
      otpErrorObj = {
        type: Errors.OTP_ERROR_TYPE,
        error: true,
        message: Errors.OTP_ERROR,
      };
    }

    // * If all the OTP fields are filled, not blank
    if (!otpErrorObj.error && otpErrorObj.message !== "otpError") {
      setLoading(true);
      const otp = otpKey1 + otpKey2 + otpKey3 + otpKey4;
      const mobileNumber = mobileNumberRef.current.value;

      const verifyOtpData = {
        ...queryValues,
        phone: mobileNumber,
        // otp_code: parseInt(otp),
        phone_otp: parseInt(otp),
        otp: parseInt(otp),
        // created_for: "16",
        id: customerDetails.contactId,
      };

      const headerData = {
        Authorization: `Bearer ${customerDetails[Authorization_TOKEN] || ""}`,
      };
      const payload = {
        verifyOtpData: verifyOtpData,
        headerData: headerData,
      };
      return new Promise((resolve, reject) => {
        props.verifyOtp(payload, resolve, reject);
      })
        .then((data) => {
          if (data.status) {
            if (!newCustomer) {
              navigate("/customers/home/dashboard");
            } else {
              switchToNextSlide(activeSlide + 1);
            }
          }
        })
        .catch((err) => {
          if (err?.response?.status === 403) {
            setError({
              error: true,
              type: Errors.OTP_ERROR_TYPE,
              message: Errors.INVALID_OTP_ERROR,
            });
          }
          // else {
          //   (true);
          // }
          setLoading(false);
          otpRefKey1.current.value = "";
          otpRefKey2.current.value = "";
          otpRefKey3.current.value = "";
          otpRefKey4.current.value = "";
        });
    } else {
      setError(otpErrorObj);
    }
  }
  // * Function to handle the Email
  function handleEmail(email, errorType) {
    if (email !== "") {
      const isEmailValid = validateEmail(email);

      if (!isEmailValid) {
        setError({
          error: true,
          type: errorType,
          message: Errors.INVALID_EMAIL_ERROR,
        });
      } else if (error.error && error.type === errorType) {
        setError({
          error: false,
          type: "",
          message: "",
        });
      }
    } else {
      setError({
        error: true,
        type: errorType,
        message: Errors.NULL_EMAIL_ERROR,
      });
    }
  }
  // * Function to handle monthly income
  function handleMonthlyIncome() {
    let monthlyIncome = monthlyIncomeRef.current.value;
    if (monthlyIncome === "") {
      setError({
        error: true,
        type: Errors.MONTHLY_INCOME_ERROR_TYPE,
        message: Errors.NULL_MONTHLY_INCOME_ERROR,
      });
      return false;
    }
    if (isNaN(monthlyIncome)) {
      setError({
        error: true,
        type: Errors.MONTHLY_INCOME_ERROR_TYPE,
        message: Errors.INVALID_FORMAT_MONTHLY_INCOME_ERROR,
      });
      monthlyIncomeRef.current.value = "";
      return false;
    }
    if (monthlyIncome <= 0) {
      setError({
        error: true,
        type: Errors.MONTHLY_INCOME_ERROR_TYPE,
        message: Errors.ZERO_MONTHLY_INCOME_ERROR,
      });
      return false;
    }
    if (monthlyIncome > 900000) {
      setError({
        error: true,
        type: Errors.MONTHLY_INCOME_ERROR_TYPE,
        message: Errors.HIGH_MONTHLY_INCOME_ERROR,
      });
      return false;
    }
    if (error.error) {
      setError({
        error: false,
        type: "",
        message: "",
      });
    }
    return true;
  }
  //Navigate
  const redirectToDashboard = () => {
    navigate("/customers/home/dashboard", {
      state: {
        ContactID, // The value you want to pass
        TokenForCustomers, // Another value you want to pass
      },
    });
  };

  // * Function to update data in journey
  async function updateJourneyData(userData) {
    let headerData = {
      Authorization: customerDetails[Authorization_TOKEN],
    };

    const payload = {
      headerData,
      details: { ...queryValues, ...userData },
    };

    try {
      const data = await new Promise((resolve, reject) => {
        props.addJourney(payload, resolve, reject);
      });
      if (userData.company_name && employmentType === "Salaried") {
        if (JourneyVersion === "J1" || !JourneyVersion) {
          setCookie(LAST_ACTIVE_JOURNEY_SLIDE, 16, { path: CookiePath });
        } else if (JourneyVersion === "J2") {
          setCookie(LAST_ACTIVE_JOURNEY_SLIDE, 17, { path: CookiePath });
        }
      } else {
        if (activeSlide == 16) {
          setCookie(LAST_ACTIVE_JOURNEY_SLIDE, 25, { path: CookiePath });
        } else {
          if (activeSlide !== 13) {
            setCookie(LAST_ACTIVE_JOURNEY_SLIDE, activeSlide + 1, {
              path: CookiePath,
            });
          }
        }
      }
      return data;
    } catch (err) {
      console.log("ERROR : ", err);
      return false;
    }
  }

  // * Function to add Email
  async function addEmail() {
    const email = emailRef.current.value;
    if (email !== "") {
      const isEmailValid = validateEmail(email);

      if (isEmailValid) {
        window.webengage.track("Email", {
          "Value Entered": email,
        });
        window.webengage.user.setAttribute("we_email", email);

        setCustomerDetails({ ...customerDetails, email });
        setLoading(true);
        // * CALL API HERE
        const response = await updateJourneyData({
          email: email,
          id: customerDetails?.contactId,
        });
        if (response) {
          switchToNextSlide(activeSlide + 1);
        }
        setLoading(false);
      } else {
        setError({
          error: true,
          type: Errors.EMAIL_ERROR_TYPE,
          message: Errors.INVALID_EMAIL_ERROR,
        });
        setLoading(false);
      }
    } else {
      setError({
        error: true,
        type: Errors.EMAIL_ERROR_TYPE,
        message: Errors.NULL_EMAIL_ERROR,
      });
    }
  }

  // * Function to add all Selector fields data (Gender, Marital Status, Employement Status)
  function addSelectorsData(fieldName, fieldValue, fieldErrorType) {
    if (fieldValue === "" || fieldValue === null) {
      setError({
        error: true,
        type: fieldErrorType,
        message: "",
      });
    } else {
      setCustomerDetails({ ...customerDetails, [fieldName]: fieldValue });
      // * Call API here
      const data = {
        [fieldName]:fieldValue,
          // fieldName !== "has_coApplicant"
          //   ? fieldValue
          //   : fieldValue === "Yes Add Co-Applicant"
          //   ? true
          //   : false,
        id: customerDetails.contactId,
      };
      const response = updateJourneyData(data);
      if (response) {
        switch (fieldName) {
          case "gender":
            window.webengage.track("Gender", {
              "Value Entered": fieldValue.toLowerCase(),
            });
            window.webengage.user.setAttribute("we_gender", "male");
            break;
          case "marital_status":
            window.webengage.track("Marital Status", {
              "Value Entered": fieldValue,
            });
            break;
          case "employee_type":
            setEmploymentType(fieldValue);
            setCookie(EMPLOYEMENT_TYPE, fieldValue, { path: CookiePath });
            window.webengage.track("Employment Type", {
              "Type Selected": fieldValue,
            });
            // navigate('/customers/dashboard');
            redirectToDashboard();
            break;
        }

        switchToNextSlide(activeSlide + 1);
      }
    }
  }
  // * Function to add monthly income
  async function addMonthlyIncome() {
    if (handleMonthlyIncome()) {
      if (!error.error && error.type !== Errors.MONTHLY_INCOME_ERROR_TYPE) {
        setLoading(true);
        const monthlyIncome = parseInt(monthlyIncomeRef.current.value);
        window.webengage.track("Net Monthly Income", {
          "Value Entered": monthlyIncome,
        });
        const data = {
          montly_income: monthlyIncome,
          id: customerDetails?.contactId,
          // salary_type: salaryTypeRef.current.value,
        };
        setCustomerDetails({
          ...customerDetails,
          monthlyIncome: data.montly_income,
          // salaryType: data.salary_type,
        });
        const response = await updateJourneyData(data);
        if (response) {
          switchToNextSlide(activeSlide + 1);
          // residentialAddress1Ref.current.focus();
        }
        setLoading(false);
      }
    }
  }
  // * Function to validate Address details
  function validateAddress(fieldValue, ERROR_TYPE, ERROR_MESSAGE) {
    if (fieldValue === "") {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: ERROR_MESSAGE,
      });
      return false;
    }
    if (/[`!@#$%^&*()_+\=\[\]{};':"\\|.<>\/?~]/.test(fieldValue)) {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.INVALID_SPECIAL_ADDRESS_ERROR,
      });
      return false;
    }
    if (!/[a-zA-Z]/.test(fieldValue)) {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.INVALID_NUMBER_ADDRESS_ERROR,
      });
      return false;
    }
    if (error.error) {
      setError({
        error: false,
        type: "",
        message: "",
      });
      return true;
    }
    return true;
  }
  // * Function to handle City and State
  function validateCityAndState(fieldValue, ERROR_TYPE) {
    if (fieldValue === "") {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.NULL_CITY_STATE_ERROR,
      });
      return false;
    }
    if (/[0-9]/.test(fieldValue)) {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.INVALID_CITY_STATE_DIGIT_ERROR,
      });
      return false;
    }
    if (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(fieldValue)) {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.INVALID_CITY_STATE_DIGIT_ERROR,
      });
      return false;
    }
    if (error.error) {
      setError({
        error: false,
        type: "",
        message: "",
      });
      return true;
    }
    return true;
  }
  // * Function to handle PinCode
  function validatePinCode(PIN, ERROR_TYPE, REFERENCE, CITY_REF, STATE_REF) {
    if (PIN === "") {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.RESIDENTIAL_PIN_ERROR,
      });
      return false;
    }
    if (isNaN(PIN)) {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.INVALID_DIGITS_PINCODE,
      });
      REFERENCE.current.value = "";
      return false;
    }
    if (PIN.length > 6 || PIN.length < 6) {
      setError({
        error: true,
        type: ERROR_TYPE,
        message: Errors.PINCODE_LENGTH_ERROR,
      });
      return false;
    }
    if (error.error) {
      setError({
        error: false,
        type: "",
        message: "",
      });
      return true;
    }
    return true;
  }
  // * Function to add Residential Address details
  async function addResidentialAddress() {
    const residentialAddress = residentialAddress1Ref.current.value;
    const residentialAddress2 = residentialAddress2Ref.current.value;
    const residentialCity = residentialCityRef.current.value;
    const residentialState = residentialStateRef.current.value;
    const pinCode = residentialPinRef.current.value;

    if (
      !validateAddress(
        residentialAddress,
        Errors.RESIDENTIAL_ADDRESS1_ERROR_TYPE,
        Errors.RESIDENTIAL_ADDRESS1_ERROR
      )
    ) {
      return false;
    }
    if (
      !validateAddress(
        residentialAddress2,
        Errors.RESIDENTIAL_ADDRESS2_ERROR_TYPE,
        Errors.RESIDENTIAL_ADDRESS2_ERROR
      )
    ) {
      return false;
    }
    if (
      !validateCityAndState(residentialCity, Errors.RESIDENTIAL_CITY_ERROR_TYPE)
    ) {
      return false;
    }
    if (
      !validateCityAndState(
        residentialState,
        Errors.RESIDENTIAL_STATE_ERROR_TYPE
      )
    ) {
      return false;
    }
    if (!validatePinCode(pinCode, Errors.RESIDENTIAL_PIN_ERROR_TYPE)) {
      return false;
    }

    if (!error.error) {
      window.webengage.track("Current Address", {
        "address line 1": residentialAddress,
      });
      window.webengage.track("Current Address", {
        "address line 2": residentialAddress2,
      });
      window.webengage.track("Current Address", {
        pincode: pinCode,
      });
      // * Call API here
      const data = {
        address_line_1: residentialAddress.trim(),
        address_line_2: residentialAddress2.trim(),
        city: residentialCity,
        state: residentialState,
        pincode: pinCode,
        id: customerDetails?.contactId,
      };

      setCustomerDetails({ ...customerDetails, ...data });

      setLoading(true);
      const response = await updateJourneyData(data);
      if (response) {
        switchToNextSlide(activeSlide + 1);
        officePinRef.current.focus();
        setLoading(false);
      }
      setLoading(false);
    }
  }
  // * Function to add Office Address details
  async function addOfficeAddress() {
    const pinCode = officePinRef.current.value;
    if (!validatePinCode(pinCode, Errors.RESIDENTIAL_PIN_ERROR_TYPE)) {
      return false;
    }

    if (!error.error) {
      const isPinCodeExist = PinCodeDirectory.lookup(pinCode);
      if (isPinCodeExist.length !== 0) {
        const officeAddressObject = {
          office_pin: pinCode,
          //officepincode: pinCode,
          id: customerDetails?.contactId,
        };
        setCustomerDetails({ ...customerDetails, ...officeAddressObject });
        setLoading(true);
        // * Call API here
        const response = await updateJourneyData(officeAddressObject);
        if (response) {
          switchToNextSlide(activeSlide + 1);
        }
      } else {
        setError({
          error: true,
          type: Errors.OFFICE_PIN_ERROR_TYPE,
          message: Errors.INVALID_OFFICE_PINCODE_ERROR,
        });
      }

      setLoading(false);
    }
  }

  // * Function to validate Company Name
  function validateCompanyName(companyName) {
    if (companyName === "") {
      setError({
        error: true,
        type: Errors.COMPANY_NAME_ERROR_TYPE,
        message: Errors.NULL_COMPANY_NAME_ERROR,
      });
      return false;
    }
    if (!/[A-Z[a-z]/.test(companyName)) {
      setError({
        error: true,
        type: Errors.COMPANY_NAME_ERROR_TYPE,
        message: Errors.INVALID_COMPANY_NAME_ERROR,
      });
      return false;
    }

    if (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(companyName)) {
      setError({
        error: true,
        type: Errors.COMPANY_NAME_ERROR_TYPE,
        message: Errors.INVALID_COMPANY_NAME_ERROR,
      });
      return false;
    }
    if (error.error && error.type === Errors.COMPANY_NAME_ERROR_TYPE) {
      setError({
        error: false,
        type: "",
        message: "",
      });
    }
    return true;
  }

  // * Function to add company name of salaried person
  async function addCompanyDetails() {
    const companyName = companyNameRef.current.value;

    if (!validateCompanyName(companyName)) return false;

    if (!error.error && error.type !== Errors.COMPANY_NAME_ERROR_TYPE) {
      window.webengage.track("Name Of Company", {
        "Name Entered": companyName,
      });
      window.webengage.user.setAttribute("we_company", companyName);

      setCustomerDetails({
        ...customerDetails,
        companyName,
      });

      // * Call API here
      setLoading(true);
      const Payload = {
        company_name: companyName,
        id: customerDetails?.contactId,
      };

      const response = await updateJourneyData(Payload);
      if (response) {
        // if (
        //   (employmentType === "Salaried" && JourneyVersion === "J1") ||
        //   (employmentType === "Salaried" && !JourneyVersion)
        // ) {
        //   switchToNextSlide(16);
        // } else
        if (employmentType === "Salaried" && JourneyVersion === "J2") {
          switchToNextSlide(10);
        } else {
          switchToNextSlide(activeSlide + 1);
        }
      }
      setLoading(false);
    }
  }

  //map two funtion here for new requirements
  const handleButtonClick1 = () => {
    addOfficeAddress();
    addCompanyDetails();
    addMonthlyIncome();
  };

  return (
    <div
      className={`journeyRightSection ${
        activeSlide ? "fullScreenMobileView" : null
      }`}
    >
      <div className="wrapper">
        {/* Slide Back Button */}
        <div
          className={`slideHeader ${
            [0, 2, 27].includes(activeSlide)
              ? "hideSlideHeader"
              : "showSlideHeader"
          }`}
        >
          <button
            className={`backBtn`}
            title="Go Back"
            onClick={() => switchToPreviousSlide(previousSlide)}
          >
            <ArrowBackRoundedIcon sx={{ color: "#2e3092" }} />
            Back
          </button>
        </div>

        {/* Carousel Container */}
        <div className="journeyCarouselContainer">
          <Carousel
            indicators=""
            controls={false}
            interval={null}
            activeIndex={activeSlide}
            id="carousel_id"
          >
            {/* Mobile Number Slide */}
            <Carousel.Item id="1" className="mobileNumberSlide">
              <div className="logoBox" sx={{ paddingTop: 20 }}>
                <img loading="lazy"  
                //src={YouindiLogo}
                src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
                />
              </div>
              <div className="carouselSlideWrapper mobileNumberSlideWrapper">
                <div className="formContent userMobileNumberForm">
                  <TextInputField
                    type="tel"
                    label="Enter your mobile number to proceed "
                    placeholder="Enter 10 digit mobile number"
                    name="mobileNumber"
                    id="mobileNumber"
                    reference={mobileNumberRef}
                    required={true}
                    maxLength="10"
                    minLength="10"
                    // onEnterHandler={sendOTP}
                    errorType={Errors.MOBILE_NUMBER_ERROR_TYPE}
                    handler={(mobileNumber) =>
                      validateMobileNumber(
                        mobileNumber,
                        Errors.MOBILE_NUMBER_ERROR_TYPE
                      )
                    }
                    autoFocus={true}
                  />

                  <div className="getOtpBtnContainer">
                    <div
                      style={{
                        display: "flex",
                        paddingTop: "10%",
                        justifyContent: "center",
                        alignItems: "left",
                      }}
                    >
                      <CheckCircleIcon style={{ color: "#2E3092" }} />{" "}
                      <div
                        style={{
                          fontSize: 12,
                          paddingTop: 4,
                          marginLeft: 10,
                        }}
                      >
                        We will use this number to communicate with you
                      </div>
                    </div>
                    <ContinueButton
                      loading={loading}
                      error={error}
                      handler={sendOTP}
                      // handler={() => setActiveSlide(20)}
                    />
                    <div className="tnc">
                      <p className="tncP">
                        By continuing you agree to our{" "}
                        <a href="https://roopya.com/terms-of-use/">
                          terms of use
                        </a>{" "}
                        and{" "}
                        <a href="https://roopya.com/privacy-policy/">
                          privacy policy
                        </a>
                      </p>
                    </div>
                  </div>

                  {/* Terms and Conditions */}
                  <div className="tncCheckBox">
                    <PowerdByRoopya />
                  </div>
                </div>
                {/* Personal Loan Details */}
              </div>
            </Carousel.Item>
            {/* OTP Verification Slide */}
            <Carousel.Item id="2" className={"otp_slide"}>
              {activeSlide === 1 && (
                <OTPSlide
                  mobileNumber = {mobileNumberRef?.current?.value || ""}
                  setActiveSlide = {setActiveSlide}
                  handleOtp = {handleOtp}
                  verifyOTP = {verifyOTP}
                  // resendOtp={resendOtp}
                  otpRefKey1 = {otpRefKey1}
                  otpRefKey2 = {otpRefKey2}
                  otpRefKey3 = {otpRefKey3}
                  otpRefKey4 = {otpRefKey4}
                  verifyOTPLoading = {loading}
                  orgLogoData = {orgLogoData}
                  ContactID = {customerDetails.contactId}
                  TokenForCustomers = {TokenForCustomers}
                />
              )}
            </Carousel.Item>
            {/* FullName DOB PAN Slide */}
            <Carousel.Item id="3">
              <FullNameDobPANSlide
                ageRef={ageRef}
                isLoading={loading}
                setLoading={setLoading}
                activeSlide={activeSlide}
                switchToNextSlide={switchToNextSlide}
                updateJourneyData={updateJourneyData}
                ContactID={customerDetails?.contactId}
                orgLogoData = {orgLogoData}

              />
            </Carousel.Item>
            {/* Gender Slide *** Selector *** */}
            <Carousel.Item id="4">
              <div className="logoBox" sx={{ paddingTop: 20 }}>
                <img loading="lazy"  
                //src={YouindiLogo} 
                src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
                />
              </div>
              <div
                className="carouselSlideWrapper"
                style={{ paddingTop: "50px", textAlign: "center" }}
              >
                <div className="typographyContainer">
                  <h1>Gender</h1>
                  <p>Please select your gender.</p>
                </div>
                <div className="genderInputContainer dataFieldsContainer selectInputContainer">
                  <div className="maleGenderBtnBox">
                    <SelectorButton
                      label="Male"
                      elementValue={selectorValues.gender}
                      error={error}
                      errorType={Errors.GENDER_ERROR_TYPE}
                      handler={(gender) =>
                        addSelectorsData(
                          "gender",
                          gender,
                          Errors.GENDER_ERROR_TYPE
                        )
                      }
                      icon={<MaleIcon sx={{ fontSize: "20px" }} />}
                      // handler={() => setActiveSlide((prev) => prev + 1)}
                    />
                  </div>
                  <div
                    className="femaleGenderBtnBox"
                    style={{ textAlign: "center" }}
                  >
                    <SelectorButton
                      label="Female"
                      elementValue={selectorValues.gender}
                      error={error}
                      errorType={Errors.GENDER_ERROR_TYPE}
                      handler={(gender) =>
                        addSelectorsData(
                          "gender",
                          gender,
                          Errors.GENDER_ERROR_TYPE
                        )
                      }
                      icon={<FemaleIcon sx={{ fontSize: "20px" }} />}
                      // handler={() => setActiveSlide((prev) => prev + 1)}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="tncCheckBox" style={{ paddingTop: "100px" }}>
                  <PowerdByRoopya />
                </div>
              </div>
            </Carousel.Item>
            {/* Marital Status Slide *** Selector *** */}
            <Carousel.Item id="5">
              <div className="logoBox" sx={{ paddingTop: 20 }}>
                <img loading="lazy"  
                //src={YouindiLogo} 
                src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
                />
              </div>
              <div className="carouselSlideWrapper">
                <div className="typographyContainer">
                  <h1>Marital Status</h1>
                  <p>Please select your marital status.</p>
                </div>
                <div className="genderInputContainer dataFieldsContainer selectInputContainer">
                  <div className="marriedStatusBtnBox">
                    <SelectorButton
                      label="Unmarried"
                      elementValue={selectorValues.maritalStatus}
                      error={error}
                      errorType={Errors.MARITAL_STATUS_ERROR_TYPE}
                      handler={(maritalStatus) =>
                        addSelectorsData(
                          "marital_status",
                          maritalStatus,
                          Errors.MARITAL_STATUS_ERROR_TYPE
                        )
                      }
                      // handler={() => setActiveSlide((prev) => prev + 1)}
                    />
                  </div>
                  <div className="marriedStatusBtnBox">
                    <SelectorButton
                      label="Married"
                      elementValue={selectorValues.maritalStatus}
                      error={error}
                      errorType={Errors.MARITAL_STATUS_ERROR_TYPE}
                      handler={(maritalStatus) =>
                        addSelectorsData(
                          "marital_status",
                          maritalStatus,
                          Errors.MARITAL_STATUS_ERROR_TYPE
                        )
                      }
                      // handler={() => setActiveSlide((prev) => prev + 1)}
                    />
                  </div>
                </div>
                <div className="tncCheckBox" style={{ paddingTop: "100px" }}>
                  <PowerdByRoopya />
                </div>
              </div>
            </Carousel.Item>
            {/* Email Slide */}
            <Carousel.Item id="6">
              <div className="logoBox" sx={{ paddingTop: 20 }}>
                <img loading="lazy"  
                //src={YouindiLogo} 
                src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
                />
              </div>
              <div className="carouselSlideWrapper">
                <div className="typographyContainer">
                  <h1 style={{ textAlign: "" }}>Enter Your Email</h1>
                  <p></p>
                </div>

                <div
                  className="emailInputContainer dataFieldsContainer"
                  style={{ textAlign: "left" }}
                >
                  <TextInputField
                    type="text"
                    label="Email Address"
                    placeholder="Enter Email Address"
                    name="email"
                    id="email"
                    reference={emailRef}
                    handler={(email) =>
                      handleEmail(email, Errors.EMAIL_ERROR_TYPE)
                    }
                    required={true}
                    errorType={Errors.EMAIL_ERROR_TYPE}
                    // onEnterHandler={addEmail}
                  />
                </div>
                <div className="emailContinueBtn">
                  <ContinueButton
                    loading={loading}
                    handler={addEmail}
                    // handler={() => setActiveSlide((prev) => prev + 1)}
                  />
                </div>
                <div className="tncCheckBox" style={{ paddingTop: "100px" }}>
                  <PowerdByRoopya />
                </div>
              </div>
            </Carousel.Item>

            {/* Current Address Details */}
            <Carousel.Item id="9">
              <div className="logoBox" sx={{ paddingTop: 20 }}>
                <img loading="lazy"  
                //src={YouindiLogo} 
                src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
                />
              </div>
              <div className="carouselSlideWrapper residentAddressSlideWrapper">
                <div className="typographyContainer" style={{ marginTop: 50 }}>
                  <h1>Enter Communication Details</h1>
                </div>
                <div
                  className="residentialInputContainer dataFieldsContainer"
                  style={{ textAlign: "left" }}
                >
                  <TextInputField
                    type="text"
                    label="Enter Address Line 1"
                    placeholder="Address"
                    name="address1"
                    id="address1"
                    reference={residentialAddress1Ref}
                    required={true}
                    errorType={Errors.RESIDENTIAL_ADDRESS1_ERROR_TYPE}
                    handler={(address1) =>
                      validateAddress(
                        address1,
                        Errors.RESIDENTIAL_ADDRESS1_ERROR_TYPE,
                        Errors.RESIDENTIAL_ADDRESS1_ERROR
                      )
                    }
                    // onEnterHandler={addResidentialAddress}
                  />
                  <TextInputField
                    type="text"
                    label="Enter Address Line 2"
                    placeholder="Address"
                    name="address2"
                    id="address2"
                    required={true}
                    reference={residentialAddress2Ref}
                    errorType={Errors.RESIDENTIAL_ADDRESS2_ERROR_TYPE}
                    handler={(address2) =>
                      validateAddress(
                        address2,
                        Errors.RESIDENTIAL_ADDRESS2_ERROR_TYPE,
                        Errors.RESIDENTIAL_ADDRESS2_ERROR
                      )
                    }
                    // onEnterHandler={addResidentialAddress}
                  />
                  <TextInputField
                    type="text"
                    label="Enter Pincode"
                    placeholder="Pin"
                    name="pin"
                    id="pin"
                    reference={residentialPinRef}
                    required={true}
                    errorType={Errors.RESIDENTIAL_PIN_ERROR_TYPE}
                    handler={(pin) =>
                      validatePinCode(
                        pin,
                        Errors.RESIDENTIAL_PIN_ERROR_TYPE,
                        residentialPinRef,
                        residentialCityRef,
                        residentialStateRef
                      )
                    }
                    // onEnterHandler={addResidentialAddress}
                  />
                  <TextInputField
                    type="text"
                    label="City"
                    placeholder="City"
                    name="city"
                    id="city"
                    reference={residentialCityRef}
                    required={true}
                    errorType={Errors.RESIDENTIAL_CITY_ERROR_TYPE}
                    handler={(residentialCity) =>
                      validateCityAndState(
                        residentialCity,
                        Errors.RESIDENTIAL_CITY_ERROR_TYPE
                      )
                    }
                    onEnterHandler={addResidentialAddress}
                  />
                  <TextInputField
                    type="text"
                    label="State"
                    placeholder="State"
                    name="state"
                    id="state"
                    reference={residentialStateRef}
                    required={true}
                    errorType={Errors.RESIDENTIAL_STATE_ERROR_TYPE}
                    handler={(residentialCity) =>
                      validateCityAndState(
                        residentialCity,
                        Errors.RESIDENTIAL_STATE_ERROR_TYPE
                      )
                    }
                    onEnterHandler={addResidentialAddress}
                  />
                </div>
                <div className="residentContinueBtn">
                  <ContinueButton
                    loading={loading}
                    handler={addResidentialAddress}
                    // handler={() => setActiveSlide((prev) => prev + 1)}
                  />
                </div>
                <div className="tncCheckBox" style={{ paddingBottom: "30px" }}>
                  <PowerdByRoopya />
                </div>
              </div>
            </Carousel.Item>
            {/* Office Address Details */}
            <Carousel.Item id="10">
              <div
                className="logoBox"
                style={{ paddingBottom: 5, marginTop: "0px" }}
              >
                <img loading="lazy"  
                //src={YouindiLogo} 
                src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`}
                />
              </div>
              <div className="carouselSlideWrapper officeAddressSlideWrapper">
                <div className="typographyContainer">
                  <h1>Register Occupation Details</h1>
                </div>
                <div
                  className="officeAddressFields dataFieldsContainer"
                  style={{ textAlign: "left" }}
                >
                  <TextInputField
                    type="text"
                    label="Company Name"
                    placeholder="Company name"
                    name="companyName"
                    id="companyName"
                    reference={companyNameRef}
                    required={true}
                    errorType={Errors.COMPANY_NAME_ERROR_TYPE}
                    handler={(companyName) => validateCompanyName(companyName)}
                    // onEnterHandler={addCompanyDetails}
                  />

                  <TextInputField
                    type="text"
                    label="Office PIN Code"
                    placeholder="Enter Office PIN Code"
                    name="pin"
                    id="pin"
                    reference={officePinRef}
                    required={true}
                    errorType={Errors.OFFICE_PIN_ERROR_TYPE}
                    handler={(pin) =>
                      validatePinCode(
                        pin,
                        Errors.OFFICE_PIN_ERROR_TYPE,
                        officePinRef,
                        officeCityRef,
                        officeStateRef
                      )
                    }
                    // onEnterHandler={addOfficeAddress}
                  />

                  <TextInputField
                    type="text"
                    label="Monthly Income"
                    placeholder="Your monthly income"
                    name="monthlyIncome"
                    id="monthlyIncome"
                    reference={monthlyIncomeRef}
                    handler={handleMonthlyIncome}
                    required={true}
                    errorType={Errors.MONTHLY_INCOME_ERROR_TYPE}
                    // onEnterHandler={addMonthlyIncome}
                  />
                </div>
                <div className="officeAddressContinueBtn">
                  <ContinueButton
                    loading={loading}
                    handler={handleButtonClick1}
                    // handler={() => setActiveSlide((prev) => prev + 1)}
                  />
                </div>
                <div className="tncCheckBox" style={{ paddingBottom: "30px" }}>
                  <PowerdByRoopya />
                </div>
              </div>
            </Carousel.Item>
            {/* Employement type *** Selector *** */}
            <Carousel.Item id="11">
              <div className="carouselSlideWrapper">
                <div className="typographyContainer">
                  <h1>Employment Type</h1>
                  <p>Please select your employment type.</p>
                </div>
                <div className="employementType selectInputContainer">
                  <div className="employementTypeBtnBox">
                    <SelectorButton
                      label="Salaried"
                      elementValue={selectorValues.employementType}
                      error={error}
                      errorType={Errors.EMPLOYEMENT_TYPE_ERROR}
                      handler={(employementType) =>
                        addSelectorsData(
                          "employee_type",
                          employementType,
                          Errors.EMPLOYEMENT_TYPE_ERROR
                        )
                      }
                      icon={<CurrencyRupeeIcon sx={{ fontSize: "30px" }} />}
                    />
                  </div>
                  <div className="employementTypeBtnBox">
                    <SelectorButton
                      label="Self-Employed"
                      elementValue={selectorValues.employementType}
                      error={error}
                      errorType={Errors.EMPLOYEMENT_TYPE_ERROR}
                      handler={(employementType) =>
                        addSelectorsData(
                          "employee_type",
                          employementType,
                          Errors.EMPLOYEMENT_TYPE_ERROR
                        )
                      }
                      icon={
                        <BusinessCenterRoundedIcon sx={{ fontSize: "30px" }} />
                      }
                    />
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  fields: state,
  profileData: state.getProfileReducer.getProfileDetailsSuccess,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOtp,
      verifyOtp,
      addJourney,
      journeyFields,
      resendOtp,
      getProfileDetails,
      getProfileDetailsSuccess,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(JourneyForm);
